<wiz-media
  *ngIf="!!wizbiiDomain && wizbiiDomain !== 'undefined' && locale === LocaleEnum.fr_FR"
  [attr.domain]="wizbiiDomain"
  cookiekey="wizbii_tokens"
  spot="MenuEntryWizbii"
></wiz-media>
